export default __webpack_public_path__ + "static/media/q27_step4.28c22e72.png";